import { PARTNER_INDUSTRY } from '@/constants';
import { AgentIntroSourceType } from '@/pages/AgentIntro/components/TrainingSourceSelector/TrainingSourceSelector.type';

type TrainingStartPayloadInput = {
	source: string;
	sourceType: AgentIntroSourceType;
	paramsString: string;
	partner_idn?: string | null;
	partner_member_idn?: string | null;
	industry?: string;
	referral?: string;
	fullName?: string;
	email?: string;
	phoneNumber?: string;
	googleMapUrl?: string;
	language?: string;
	countryCode?: string;
	externalAccountNumber?: string;
	accountManagers?: string;
	technicalOwners?: string;
	notifications?: string;
	comment?: string;
	externalOwnerAccountId?: string;
	hashExternalAccountId?: string;
	userAgent: string;
};

const normalizeWebsiteSource = (source: string) =>
	source.startsWith('http://') || source.startsWith('https://')
		? source
		: `http://${source}`;

const optionalField = (name: string, value?: string | null) =>
	value ? [{ name, value }] : [];

const resolveGoogleMapValue = (
	source: string,
	sourceType: AgentIntroSourceType,
	googleMapUrl?: string
) =>
	sourceType === AgentIntroSourceType.GoogleMap ? source : (googleMapUrl ?? '');

export const buildTrainingStartPayload = ({
	source,
	sourceType,
	paramsString,
	partner_idn,
	partner_member_idn,
	industry,
	referral,
	fullName,
	email,
	phoneNumber,
	googleMapUrl,
	language,
	countryCode,
	externalAccountNumber,
	accountManagers,
	technicalOwners,
	notifications,
	comment,
	externalOwnerAccountId,
	hashExternalAccountId,
	userAgent
}: TrainingStartPayloadInput) => {
	const websiteSource = normalizeWebsiteSource(source);
	const googleMapValue = resolveGoogleMapValue(
		source,
		sourceType,
		googleMapUrl
	);

	return [
		...optionalField('partner_idn', partner_idn),
		...optionalField('partner_member_idn', partner_member_idn),
		{ name: 'should_be_initialized', value: 'true' },
		{ name: 'industry', value: PARTNER_INDUSTRY || industry || '' },
		{ name: 'referral', value: referral || '' },
		{ name: 'full_name', value: fullName || '' },
		{ name: 'email', value: email || '' },
		{ name: 'phone_number', value: phoneNumber || '' },
		{ name: 'google_map_url', value: googleMapValue },
		{ name: 'source', value: websiteSource },
		{ name: 'source_type', value: sourceType },
		{ name: 'language', value: language || 'en' },
		{ name: 'country_code', value: countryCode || '' },
		{ name: 'external_account_number', value: externalAccountNumber || '' },
		{ name: 'account_managers', value: accountManagers || '' },
		{ name: 'technical_owners', value: technicalOwners || '' },
		{ name: 'notifications', value: notifications || '' },
		{ name: 'comment', value: comment || '' },
		{ name: 'query_params', value: paramsString },
		{ name: 'external_owner_account_id', value: externalOwnerAccountId || '' },
		{ name: 'hash_external_account_id', value: hashExternalAccountId || '' },
		{ name: 'user_agent', value: userAgent }
	];
};
